module.exports = __webpack_public_path__ + "static/media/astonished-emoji-svgrepo-com.69f466e9.svg";